import React, { PropsWithChildren, useMemo } from 'react';
import { RouteObject, RouterProvider, createBrowserRouter } from 'react-router-dom';

interface IPlacebo {
  localRoutes: RouteObject[];
}

const Placebo: React.FC<PropsWithChildren & IPlacebo> = ({ children, localRoutes }) => {
  const router = useMemo(() => {
    return createBrowserRouter([
      {
        //path: '/',
        path: '/bc',
        element: children,
        children: localRoutes,
      },
    ]);
  }, [localRoutes]);

  return <RouterProvider router={router} />;
};

export default Placebo;
